export const DISCOVERY_LINK = "/";
